import React, { Component } from "react";
import {
  Card,
  Row,
  Col,
  Button,
  Form,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import DatatableHeader from "../DatatableHeader/DatatableHeader";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { connect } from "react-redux";
import { saveAs } from "file-saver";
import { SuperAdminAction, EnforcementActions } from "../../Actions";
import Loader from "../Loader/Loader";
import CustomContentAlert, {
  findBySearch,
  tableHeightScrollBars,
  scroolToTop,
} from "../helper";
import isEqual from "lodash/isEqual";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PropertDetails from "../LandingPage/PropertySelection";
import moment from "moment";
const moment_timezone = require("moment-timezone");
class CitationIssuedByEnforcer extends Component {
  constructor(props) {
    super(props);
    const today = new Date();
    const datebeforeThirtyDays = today.setDate(today.getDate() - 30);
    this.state = {
      searchedTicketSummary: [],
      PropertyId: this.props.PropertyId,
      loader: false,
      searchValue: "",
      api_response: false,
      show_alert: false,
      api_success_message: "",
      api_error_message: "",
      page: 1,
      Norow: 100,
      findMore: false,
      count: 0,
      timezone: this.props.timezone,
      property: this.props.property,
      show: false,
      state: "",
      selectedProperty: "",
      selectedPropertyObj: {},
      all_proparties: [],
      childcheckbox: true,
      lot_id: "",
      startDate: new Date(datebeforeThirtyDays),
      endDate: new Date(),
      currentDate: "",
      month: "",
      year: "",
      selectedRadio: "",
      activeTab: "1",
      currentSummaryDate: "",
      summaryMonth: "",
      finalTableHeight: 0,
      issuedSummaryList: [],
      selectedDomainName: "",
      daysDifference: 30,
    };

    this.customStyles = {
      rows: {
        style: {
          minHeight: "72px", // override the row height
        },
      },
      headCells: {
        style: {
          paddingLeft: "8px", // override the cell padding for head cells
          paddingRight: "8px",
        },
      },
      cells: {
        style: {
          paddingLeft: "8px", // override the cell padding for data cells
          paddingRight: "8px",
        },
      },
    };

    this.columns = [
      {
        name: "ENFORCER",
        cell: (row) => (
          <div>
            <OverlayTrigger
              delay={{ show: 250, hide: 400 }}
              placement={"top"}
              overlay={
                <Tooltip id={`tooltip-qw`}>
                  {row?.Enforcer ? row?.Enforcer : "-"}
                </Tooltip>
              }
            >
              <div>
                <a>{row?.Enforcer ? row?.Enforcer : "-"}</a>
              </div>
            </OverlayTrigger>
          </div>
        ),
        selector: (row) => row?.Enforcer,
        sortable: true,
      },
      {
        name: "Site",
        cell: (row) => (
          <div>
            <OverlayTrigger
              delay={{ show: 250, hide: 400 }}
              placement={"top"}
              overlay={
                <Tooltip id={`tooltip-qw`}>
                  {row.domain ? row.domain : "-"}
                </Tooltip>
              }
            >
              <div>
                <a>{row.domain ? row.domain : "-"}</a>
              </div>
            </OverlayTrigger>
          </div>
        ),
        selector: (row) => row.domain,
      },
      {
        name: "Total Issued #",
        minWidth: "130px",
        cell: (row) => (
          <div>
            <a>{row.TotalCount ? row.TotalCount : "-"}</a>
          </div>
        ),
        selector: (row) => row.TotalCount,
      },
      {
        name: "Total Issued $",
        minWidth: "130px",
        sortable: true,
        cell: (row) => (
          <div>
            <a>{row?.TotalAmount ? row?.TotalAmount : "-"}</a>
          </div>
        ),
        selector: (row) => row?.TotalAmount,
      },
    ];
  }

  componentDidMount = async () => {
    this.setState({ loader: true });
    const { PropertyId, timezone, childcheckbox, startDate, endDate } =
      this.state;
    const pageobj = { PropertyId, timezone, childcheckbox };
    if (startDate) {
      pageobj.weekstartDate = startDate;
    }
    if (endDate) {
      pageobj.weekEndDate = endDate;
    }
    await this.props.getCitationIssuedByEnforcerSummary(pageobj);
    this.setState({
      issuedSummaryList:
        this.props.ticketSummary &&
        this.props.ticketSummary.rows &&
        this.props.ticketSummary.rows.length
          ? JSON.parse(JSON.stringify(this.props.ticketSummary.rows))
          : [],
      api_response: this.props.api_response,
      count: this.props.ticketSummary.count,
    });
    this.setState({ loader: false });
    const height = tableHeightScrollBars();
    this.setState({
      finalTableHeight: height,
    });

    await this.props.get_all_properties();
    this.setState(
      {
        api_response: this.props?.api_response,
        all_proparties: this.props?.getAllProperties,
      },
      async () => {
        const selectedPropertyObj = this.state.all_proparties.find(
          (item) => item.id === this.state.PropertyId
        );
        const selectedPropertyName = selectedPropertyObj
          ? selectedPropertyObj.site_name
          : "";
        const selectedDomainName = selectedPropertyObj
          ? selectedPropertyObj.domain
          : "";
        await this.props.setDomainHeader(
          selectedPropertyName,
          selectedDomainName
        );
        await this.props.selected_Property(selectedPropertyObj);
        if (selectedPropertyObj) {
          this.setState({
            selectedPropertyObj: {
              label: selectedPropertyObj.site_name,
              value: selectedPropertyObj.id,
            },
            selectedProperty: PropertyId,
            selectedDomainName: selectedPropertyObj.site_name,
          });
        }
      }
    );
  };

  changeProperty(event) {
    this.setState(
      {
        selectedProperty: event.value,
        selectedPropertyObj: event,
        endDate: "",
        year: "",
        summaryMonth: "",
        weekstartDate: "",
        weekEndDate: "",
        month: null,
        currentSummaryDate: "",
        currentDate: null,
        selectedRadio: null,
        loader: false,
      },
      () => {
        const selectedPropertyObj = this.state.all_proparties.find(
          (item) => item.id === this.state.selectedProperty
        );

        this.props.selected_Property(selectedPropertyObj);
        this.setState({
          pageDropdownDisabled: false,
        });
      }
    );
  }

  handleCheckBox = () => {
    this.setState({ childcheckbox: !this.state.childcheckbox });
  };

  componentDidUpdate = async (prevProps) => {
    if (!isEqual(prevProps.ticketSummary, this.props.ticketSummary)) {
      this.setState({
        issuedSummaryList:
          this.props.ticketSummary &&
          this.props.ticketSummary.rows &&
          this.props.ticketSummary.rows.length
            ? JSON.parse(JSON.stringify(this.props.ticketSummary.rows))
            : [],
        count: this.props.ticketSummary.count,
      });
    }
  };

  handleChangeStartingDates = (date) => {
    if (date) {
      const { daysDifference } = this.state;
      const end = new Date(date);
      end.setDate(date.getDate() + daysDifference);
      let endDate = new Date();
      if (new Date() >= end) {
        endDate = end;
      }
      this.setState({
        startDate: date,
        year: "",
        summaryMonth: "",
        weekstartDate: "",
        weekEndDate: "",
        month: null,
        endDate: endDate,
        currentSummaryDate: null,
        currentDate: null,
        selectedRadio: null,
        loader: false,
      });
    }
  };

  handleChangeEndDates = (date) => {
    if (date) {
      const { daysDifference, startDate } = this.state;
      const start = new Date(date);
      start.setDate(date.getDate() - daysDifference);
      let startDateSelection;
      if (startDate) {
        startDateSelection = startDate;
      } else {
        startDateSelection = start;
      }
      this.setState({
        endDate: date,
        startDate: startDateSelection,
        year: "",
        summaryMonth: "",
        weekstartDate: "",
        weekEndDate: "",
        month: null,
        currentSummaryDate: null,
        currentDate: null,
        selectedRadio: null,
        loader: false,
      });
    }
  };

  handleExport = async () => {
    const {
      timezone,
      PropertyId,
      summaryMonth,
      currentSummaryDate,
      startDate,
      endDate,
      lot_id,
      selectedPropertyObj,
      year,
      selectedRadio,
      childcheckbox,
      selectedDomainName,
    } = this.state;
    const pageobj = { timezone, exportData: true };
    if (Object.keys(selectedPropertyObj).length) {
      pageobj.PropertyId = selectedPropertyObj.value;
    } else {
      pageobj.PropertyId = PropertyId;
    }
    if (startDate) {
      pageobj.weekstartDate = startDate;
    }
    if (endDate) {
      pageobj.weekEndDate = endDate;
    }
    if (summaryMonth) {
      pageobj.summaryMonth = summaryMonth;
    }
    if (year) {
      pageobj.year = moment_timezone(year).format("YYYY");
    }
    if (currentSummaryDate) {
      pageobj.currentSummaryDate = currentSummaryDate;
    }
    if (lot_id) {
      pageobj.lot_id = lot_id;
    }
    if (selectedRadio) {
      pageobj.selectedRadio = selectedRadio;
    }
    if (childcheckbox) {
      pageobj.childcheckbox = childcheckbox;
    }
    const bufferData = await this.props.getCitationIssuedByEnforcerSummary(
      pageobj
    );
    const currentTimeDate = moment().format("YYYYMMDD-hhmmss");
    const exportDataName = `CITATION-ISSUED-BY-ENFORCER-${currentTimeDate}-${selectedDomainName}.xls`;
    if (bufferData) {
      saveAs(
        new Blob([bufferData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        exportDataName
      );
    }
  };

  handleFilterByDate = (date) => {
    this.setState({
      currentSummaryDate: date,
      summaryMonth: "",
      weekstartDate: "",
      weekEndDate: "",
      year: "",
      month: null,
      startDate: null,
      endDate: null,
      currentDate: null,
      selectedRadio: null,
      loader: false,
    });
  };

  handleSearchSummary = async () => {
    this.setState({ loader: true });
    const {
      timezone,
      PropertyId,
      summaryMonth,
      currentSummaryDate,
      startDate,
      endDate,
      lot_id,
      selectedPropertyObj,
      year,
      selectedRadio,
      childcheckbox,
    } = this.state;
    const pageobj = { timezone };
    if (Object.keys(selectedPropertyObj).length) {
      pageobj.PropertyId = selectedPropertyObj.value;
    } else {
      pageobj.PropertyId = PropertyId;
    }
    if (startDate) {
      pageobj.weekstartDate = startDate;
    }
    if (endDate) {
      pageobj.weekEndDate = endDate;
    }
    if (summaryMonth) {
      pageobj.summaryMonth = summaryMonth;
    }
    if (year) {
      pageobj.year = moment_timezone(year).format("YYYY");
    }
    if (currentSummaryDate) {
      pageobj.currentSummaryDate = currentSummaryDate;
    }
    if (lot_id) {
      pageobj.lot_id = lot_id;
    }
    if (selectedRadio) {
      pageobj.selectedRadio = selectedRadio;
    }
    if (childcheckbox) {
      pageobj.childcheckbox = childcheckbox;
    }
    await this.props.getCitationIssuedByEnforcerSummary(pageobj);
    this.setState({
      api_response: this.props.api_response,
      count: this.props.ticketSummary.count,
    });
    this.setState({ loader: false });
    document.body.classList.remove("foc-open");
  };

  hideSlider = () => {
    document.body.classList.remove("foc-open");
  };

  handleResetSummary = async () => {
    const { PropertyId, daysDifference, selectedDomainName } = this.state;
    const today = new Date();
    const datebeforeThirtyDays = today.setDate(
      today.getDate() - daysDifference
    );
    this.setState({
      currentSummaryDate: "",
      summaryMonth: "",
      lot_id: "",
      loader: false,
      selectedRadio: null,
      year: null,
      selectedPropertyObj: {
        label: selectedDomainName,
        value: PropertyId,
      },
      selectedProperty: PropertyId,
      childcheckbox: true,
      page: 1,
      Norow: 100,
      startDate: new Date(datebeforeThirtyDays),
      endDate: new Date(),
    });
  };

  handleSearchChange = async ({ target }) => {
    this.setState({ searchValue: target.value }, async () => {
      const columnList = ["domain", "Enforcer", "TotalCount", "TotalAmount"];
      if (this.state.searchValue.length) {
        this.setState(
          {
            searchedTicketSummary: findBySearch(
              this.state.searchValue,
              this.state.issuedSummaryList,
              this.state.issuedSummaryList,
              columnList,
              this.props.timezone
            ),
          },
          () => {
            this.setState({ count: this.state.searchedTicketSummary.length });
          }
        );
      } else {
        this.setState({
          count: this.props.ticketSummary.count,
          issuedSummaryList: this.props.ticketSummary.rows,
          searchedTicketSummary: [],
        });
      }
    });
  };

  addDays = (date, days) => {
    let endDate = new Date();
    if (date) {
      const end = new Date(date);
      end.setDate(date.getDate() + days);
      if (new Date() >= end) {
        endDate = end;
      }
    }
    return endDate;
  };

  dataTableHandle = (ticketList, searchedTicketSummary, searchValue) => {
    return (
      <DataTable
        data={
          searchValue && searchValue.length ? searchedTicketSummary : ticketList
        }
        columns={this.columns}
        customStyles={this.customStyles}
        responsive={true}
        defaultSortAsc={true}
        fixedHeader={true}
        onChangePage={scroolToTop}
        fixedHeaderScrollHeight={this.state.finalTableHeight}
        pagination={true}
        paginationPerPage={this.state.Norow}
        paginationTotalRows={this.state.count}
        paginationRowsPerPageOptions={[100, 200, 300, 400]}
      />
    );
  };

  render() {
    const {
      loader,
      childcheckbox,
      startDate,
      endDate,
      currentSummaryDate,
      issuedSummaryList,
      searchValue,
      daysDifference,
      searchedTicketSummary,
    } = this.state;

    return (
      <div>
        <Card className="mb-0">
          <Card.Body className="pos-rel-overflow-hide">
            <>
              <div className="sidebarFilter">
                <Card className="contact-container mb-0">
                  <Card.Header
                    style={{ backgroundColor: this.props.main_body }}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <Card.Title as="h5">Citation Issued Summary</Card.Title>
                      <a
                        onClick={this.hideSlider}
                        href="javascript:void(0);"
                        className="btn btn-sm border-0 bg-light rounded-circle  w-30px h-30px d-flex align-items-center justify-content-center"
                      >
                        <i className="fa fa-times" aria-hidden="true"></i>
                      </a>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md="12">
                        <div className="mb-2">
                          <label className="fancy-checkbox">
                            <input
                              type="checkbox"
                              name={"childcheckbox"}
                              checked={childcheckbox}
                              onChange={this.handleCheckBox}
                              className="custom-control-input"
                              id="childcheckbox1"
                            ></input>
                            <span>
                              <i></i>Include Children Sites
                            </span>
                          </label>
                        </div>
                      </Col>
                      <Col md="12">
                        <PropertDetails
                          selectedPropertyObj={this.state.selectedPropertyObj}
                          changeProperty={this.changeProperty.bind(this)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <Form.Group>
                          <label className="mb-0 mr-2">DATE:</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="Select Date"
                            selected={currentSummaryDate}
                            value={currentSummaryDate}
                            disabled={loader}
                            selectsStart
                            timeInputLabel="Time:"
                            onChange={this.handleFilterByDate}
                            dateFormat="MM/dd/yyyy"
                            maxDate={new Date()}
                          />
                        </Form.Group>
                      </Col>
                      <Col md="12">
                        <Form.Group>
                          <label className="mb-0 mr-2">START DATE:</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="Select Start Date"
                            selected={startDate}
                            defaultHour={24}
                            value={startDate}
                            disabled={loader}
                            selectsStart
                            timeInputLabel="Time:"
                            onChange={this.handleChangeStartingDates}
                            dateFormat="MM/dd/yyyy"
                            startDate={startDate}
                            endDate={endDate}
                            maxDate={new Date()}
                          />
                        </Form.Group>
                      </Col>
                      <Col md="12">
                        <Form.Group>
                          <label className="mb-0 mr-2">END DATE:</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="Select End Date"
                            selected={endDate}
                            disabled={loader}
                            value={endDate}
                            selectsEnd
                            timeInputLabel="Time:"
                            onChange={this.handleChangeEndDates}
                            dateFormat="MM/dd/yyyy"
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            maxDate={this.addDays(startDate, daysDifference)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                  <Card.Footer className="text-right justify-content-between d-flex">
                    <Button
                      variant="info"
                      className="h-40 custom-btn-secondary btn-sm ml-2"
                      onClick={this.handleResetSummary}
                      disabled={loader}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="info"
                      className="h-40 btn-fill btn-sm"
                      onClick={this.handleSearchSummary}
                      disabled={loader}
                    >
                      Search
                    </Button>
                  </Card.Footer>
                </Card>
              </div>
              <header>
                <div className="active-permit-header sm-flex-column sm-align-items-start">
                  <h5 className="mb-2 mb-md-0">Citation Issued Summary</h5>
                  <div className="filter-button d-flex flex-wrap">
                    <div className="d-flex align-items-center search-mb-0">
                      <DatatableHeader
                        className="mt-0 mb-0"
                        searchValue={searchValue}
                        HandleChange={this.handleSearchChange}
                      />
                    </div>
                    <div className="ml-2">
                      <Button
                        variant="info"
                        className="btn-fill btn-sm"
                        onClick={this.handleExport}
                        size="medium"
                        disabled={issuedSummaryList.length > 0 ? 0 : 1}
                      >
                        Export
                      </Button>
                    </div>
                  </div>
                </div>
              </header>
            </>
            {loader ? (
              <Loader />
            ) : (
              <>
                {this.state.show_alert && (
                  <CustomContentAlert
                    delay={4000}
                    message={this.state.api_success_message}
                    className="toast-success"
                  />
                )}
                <>
                  <div className="citation-list-table list-of-ravenue-table">
                    {this.dataTableHandle(
                      issuedSummaryList,
                      searchedTicketSummary,
                      searchValue
                    )}
                  </div>
                </>
              </>
            )}
          </Card.Body>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = ({
  UserProfileDetails,
  APIResponseDetails,
  Logindetails,
  SuperAdminDetails,
  EnforcementDetails,
}) => {
  const { api_response, api_error_message, api_success_message } =
    APIResponseDetails;
  const { property_id: PropertyId, timezone, property } = UserProfileDetails;
  const { citationSummaryList: ticketSummary } = EnforcementDetails;
  const { backgroundColor } = Logindetails;
  const { getAllProperties } = SuperAdminDetails;
  const { MainBackground: main_body } = backgroundColor;
  return {
    api_response,
    api_error_message,
    api_success_message,
    PropertyId,
    timezone,
    property,
    main_body,
    getAllProperties,
    ticketSummary,
  };
};

const mapStateToDispatch = {
  setDomainHeader: SuperAdminAction.setDomainHeader,
  get_all_properties: SuperAdminAction.get_all_properties,
  selected_Property: SuperAdminAction.selected_Property,
  getCitationIssuedByEnforcerSummary:
    EnforcementActions.getCitationIssuedByEnforcerSummary,
};

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(CitationIssuedByEnforcer);
